export const ENROLLMENT_SUCCESSFUL = 'ENROLLMENT_SUCCESSFUL';

export const enrollmentSuccessful = payload => dispatch =>
  dispatch({
    type: ENROLLMENT_SUCCESSFUL,
    payload,
  });
